const dateFormat = {
  date: {
    zh: 'yyyy-MM-dd',
    en: 'MMM d, yyyy'
  },
  dateYearMonth: {
    zh: 'yyyy-MM',
    en: 'MMM, yyyy'
  },
  dateMonthDay: {
    zh: 'MM-dd',
    en: 'MMM d'
  },
  dateTime: {
    zh: 'yyyy-MM-dd HH:mm',
    en: 'MMM d, yyyy HH:mm'
  },
  dateTimeHasSeconds: {
    zh: 'yyyy-MM-dd HH:mm:ss',
    en: 'MMM d, yyyy HH:mm:ss'
  },
  weekDateTime: {
    zh: 'ddd, yyyy-MM-dd, HH:mm',
    en: 'ddd, MMM d, yyyy HH:mm'
  }
};

export const getDateFormat = (locale) => {
  const result = {};
  const keys = Object.keys(dateFormat);
  keys.forEach(key => {
    result[key] = dateFormat[key][locale];
  });
  return result;
};